import React, {memo, useContext, useState} from "react";
import {Toolbar} from "@material-ui/core";
import __ from "lodash";
import ChromeTabs from "../../../controls/ChromeTabs";
import CompanyContactList from "./CompanyContactList";
import CompanyMessagingList from "./CompanyMessagingList";
import CompanyUserList from "./CompanyUserList";
import CompanyDetailsForm from "./CompanyDetailsForm";
import SystemContext from "../../../SystemContext";
import {useAuth0} from "@auth0/auth0-react";
import Button from "@material-ui/core/Button";
import FlightCrewList from "./FlightCrewList";

const AccessControl = require ("../../../AccessControl");

const CompanyDetailsContainer = (_props) => {
  const {isAuthenticated, user} = useAuth0();

  const props = {
    canEdit: false,
    ..._props
  }

  const classes = props.classes;

  const companyTabs =
    [
      {label: "Details", value: "details"},
      {label: "Contacts", value: "contacts"},
      {label: "Messaging", value: "messaging"},
    ];

  const [currentTab, setCurrentTab] = useState("details");
  const [selectedRecord, setSelectedRecord] = useState({});

  if (AccessControl.userHasAccess(user, ["Super Admin", "Admin"]) && selectedRecord && !selectedRecord.isFreesale)
    companyTabs.push ({label: "System Users", value: "users"});

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('CompanyManagementList.rowSelected', (record)=> {
      setSelectedRecord(record);
    });
  }

  const handleTabChange = (e, i) => {
    setCurrentTab(i);
  }

  const renderTabContent = () => {
    if (currentTab === "crew") {
      return (
        <div className={classes.rooted} >
          <FlightCrewList
            record={selectedRecord}
            canEdit={props.canEdit}
            fullPage
          />
        </div>
      )
    }
    if (currentTab === "contacts") {
      return (
        <div className={classes.rooted} >
          <CompanyContactList
            record={selectedRecord}
            canEdit={props.canEdit}
            fullPage
          />
        </div>
      )
    }
    if (currentTab === "messaging") {
      return (
        <div className={classes.rooted} >
          <CompanyMessagingList
            record={selectedRecord}
            canEdit={props.canEdit}
            fullPage
          />
        </div>
      )
    }
    if (currentTab === "users") {
      return (
        <div className={classes.rooted} >
          <CompanyUserList
            classes={classes}
            record={selectedRecord}
            canEdit={props.canEdit}
            fullPage
          />
        </div>
      )
    }
    if (__.isEmpty(selectedRecord)) {
      return (
        <div style={{position: "relative", top: "50%"}}>
          <Button color={"primary"}>Select a Company to view and edit</Button>
        </div>
      )
    } else {
      return (
        <div style={{width: "calc(100vw - 645px)", height: "100%", backgroundColor: "#ffffff"}}>
          <CompanyDetailsForm
            canEdit={props.canEdit && !selectedRecord?.isFreesale}
            record={selectedRecord}
            classes={classes}
          />
        </div>
      )
    }

  }

  if (selectedRecord.isAirline && __.find(companyTabs, {value: "crew"}) === undefined) {
    companyTabs.push ({label: "Flight Crew", value: "crew"});
  }

  return (isAuthenticated &&
    <div style={{width: "100%", marginRight: 20}}>
      <Toolbar >
        <ChromeTabs
          id={"CompanyDetails"}
          //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}
          style={{ marginTop: -10 }}
          tabs={companyTabs}
          tabStyle={{
            bgColor: "#E6E8EB",
            selectedBgColor: "#ffffff",
            color: "rgba(0,0,0,0.87)",
          }}
          tabProps={{
            disableRipple: false,
          }}
          value={currentTab}
          onChange={handleTabChange}
        />
      </Toolbar>
      <div style={{width: "100%", height: "calc(100vh - 224px)", backgroundColor: "#ffffff", marginTop: -10 }}>
        {renderTabContent()}
      </div>
    </div>
  )
}

export default memo(CompanyDetailsContainer);
